export function parseURL<T>(query: string): T {
    const queryString = query.substr(1);

    const urlEntries = queryString.split('&').reduce<[keyof T, string | number][]>((acc, data) => {
        const [key, value] = data.split('=');
        if (key !== undefined && value !== undefined) {
            const decodeValue = decodeURIComponent(value.replace(/\+/g, '%20'));

            acc.push([
                key as keyof T,
                decodeValue,
            ]);
        }

        return acc;
    }, []);

    return Object.fromEntries(urlEntries) as T;
}
